export class Users {
    public Id: number;
    public Username: string;
    public Roles: string[];
    public Area: string;
}